"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_FEE = void 0;
exports.STANDARD_FEE = {
    amount: [
        {
            denom: "uaxl",
            amount: "1000",
        },
    ],
    gas: "5000000",
};
//# sourceMappingURL=index.js.map